module.exports = __webpack_public_path__ + "img/虎纽印章详情.63f083d4.jpg";